@if (isCellEmpty) {
  <span>--</span>
  <span class="is-visually-hidden">{{ 'table.notAvailable' | translate }}</span>
} @else {
  @switch (_type) {
    @case (DataTableColumnTypeEnum.media) {
      <ng-container *ngTemplateOutlet="dataTableMedia; context: { content: cellContent }" />
    }
    @case (DataTableColumnTypeEnum.tag) {
      <ng-container *ngTemplateOutlet="dataTableTag; context: { content: cellContent }" />
    }
    @case (DataTableColumnTypeEnum.button) {
      <ng-container *ngTemplateOutlet="dataTableButton; context: { content: cellContent }" />
    }
    @case (DataTableColumnTypeEnum.scale) {
      <ng-container *ngTemplateOutlet="dataTableScale; context: { content: cellContent }" />
    }
  }
}

<!-- Cell's Media Template -->
<ng-template #dataTableMedia let-content="content">
  @if (content.icon) {
    <sd-icon [name]="content.icon" [size]="isMobile ? IconSize.small : IconSize.xxl" />
  }
  @if ((!isContentPictoEmpty && !content.icon) || (content.value && !content.icon && !content.media)) {
    <sd-icon
      [size]="IconSize.medium"
      [name]="content.value ? 'icon-check-circle' : 'icon-delete'"
      [attr.data-color]="content.value ? 'success-base' : 'error-base'"
    />
  }
  @if (content.media && !content.icon) {
    <sd-banner
      [media]="content.media"
      [isFit]="true"
      [isAriaHidden]="true"
      [imgRatio]="ImageRatioEnum.r1_1"
    />
  }
  <ng-container *ngTemplateOutlet="defaultText; context: { $implicit: content.label }" />
</ng-template>

<!-- Cell's Tag Template -->
<ng-template #dataTableTag let-content="content">
  @if (content.tag) {
    <sd-tag [tagData]="content.tag" />
  }
  <ng-container *ngTemplateOutlet="defaultText; context: { $implicit: content.label }" />
</ng-template>

<!-- Cell's Button Template -->
<ng-template #dataTableButton let-content="content">
  <ng-container *ngTemplateOutlet="defaultText; context: { $implicit: content.label }" />
  @if (content.button?.isButton) {
    <button
      sd-button
      (click)="onClick(content.button)"
      [isSmall]="isMobile && content.button.label"
      [isIcon]="isMobile && !content.button.label"
      [icon]="content.icon ? content.icon : 'icon-cart'"
    >
      <span [class]="isMobile && !content.button.label ? 'is-visually-hidden' : ''">
        {{content.button.label ? content.button.label : 'actions.cart.add' | translate}}
      </span>
    </button>
  }
</ng-template>

<!-- Cell's Scale Template -->
<ng-template #dataTableScale let-content="content">
  @if (content.scale?.maxStar) {
    <sd-rating
      [labelTitle]="content.scale.libelle || content.label"
      [maxStar]="content.scale.maxStar"
      [labelHidden]="true"
      [isScale]="content.scale.isScale"
      [readonly]="true"
      [ratings]="{ averageRatings: content.scale.value }"
    />
  }
  <ng-container *ngTemplateOutlet="defaultText; context: { $implicit: content.label }" />
</ng-template>

<!-- Default text Cell Template -->
<ng-template #defaultText let-text>
  @if (text?.url) {
    <sd-link
      [link]="text"
      [indexFollow]="text.indexFollow !== undefined ? text.indexFollow : true"
      (clicked)="onLinkClicked($event)"
    >
      @if (text.linkName) {
        <sd-html [html]="text.linkName" tag="span" />
      }
    </sd-link>
  } @else {
    <sd-html [html]="text" />
  }
</ng-template>
